/**
 * buckets.ts — shared heatmap-bucket maths for the analytics kit (#22/#24,
 * 2026-07-21). Counts only — never money (the kit renders clinician surfaces).
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: analytics batch (#21-25).
 *
 * WHY here: both busiest-times surfaces (the admin AnalyticsTab and the
 * clinician My-stats tab) sum the clinic + orders activity reads cell-by-cell
 * before handing the result to Heatmap — one implementation next to the
 * renderer instead of a copy in each tab.
 */
import type { ActivityBucket } from '../api/types';

/** Sum two sparse bucket lists into one dense-enough list keyed by day:hour. */
export function mergeBuckets(a: ActivityBucket[], b: ActivityBucket[]): ActivityBucket[] {
  const byKey = new Map<string, ActivityBucket>();
  for (const x of [...a, ...b]) {
    const key = `${x.dayOfWeek}:${x.hour}`;
    const cur = byKey.get(key);
    if (cur) cur.count += x.count;
    else byKey.set(key, { dayOfWeek: x.dayOfWeek, hour: x.hour, count: x.count });
  }
  return [...byKey.values()];
}
